"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trecastelli": {
    "5d95ead1": [{
      "hkey": "ed5cc414",
      "slug": "trecastelli",
      "name": "Trecastelli",
      "primary": true,
      "skipSearch": false
    }],
    "francavilla": [{
      "hkey": "ed5cc414",
      "slug": "trecastelli",
      "name": "Trecastelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01dad632": [{
      "hkey": "ed5cc414",
      "slug": "trecastelli",
      "name": "Trecastelli",
      "primary": true,
      "skipSearch": false
    }],
    "giombino": [{
      "hkey": "ed5cc414",
      "slug": "trecastelli",
      "name": "Trecastelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9930224": [{
      "hkey": "e5ad69d8",
      "slug": "passo-ripe",
      "name": "Passo Ripe",
      "primary": true,
      "skipSearch": false
    }],
    "passo-di-ripe": [{
      "hkey": "e5ad69d8",
      "slug": "passo-ripe",
      "name": "Passo Ripe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;